import { HTMLAttributes } from 'react';
import {
  Button,
  HStack,
  SVG,
} from 'app/pages/request-single-page/components-v4';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import { useMedia } from 'app/pages/request-single-page/components-v4/media';

export const ThumbnailsControls = () => {
  const { scrollPrev, scrollNext, canScrollPrev, canScrollNext } = useMedia();

  const visible = canScrollPrev || canScrollNext;

  return (
    <HStack
      spacing="s"
      style={{
        opacity: visible ? '1' : '0',
        visibility: visible ? 'visible' : 'hidden',
        transitionDuration: '200ms',
      }}
    >
      <Button
        iconButton={<SVG src={Icons.Chevron} props={{ deg: 90 }} />}
        mode="neutral"
        variant="ghost"
        size="xs"
        disabled={!canScrollPrev}
        onClick={scrollPrev}
      />
      <Button
        iconButton={<SVG src={Icons.Chevron} props={{ deg: -90 }} />}
        mode="neutral"
        variant="ghost"
        size="xs"
        disabled={!canScrollNext}
        onClick={scrollNext}
      />
    </HStack>
  );
};
